import { API_URL, PRICE_SCHEME_HEADER, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const deletePriceBand = async (priceBandId: string, priceSchemeId: string) => {
  const res = await fetch(`${API_URL}/pricing/price-bands/${priceBandId}`, {
    method: 'DELETE',
    headers: {
      [PRICE_SCHEME_HEADER]: priceSchemeId,
    },
  });
  if (res.status === Status.BAD_REQUEST) {
    const json = await res.json();
    throw new Error(json.message);
  }
  if (res.status === Status.NO_CONTENT) return {};
};
